import Helpers from '../helpers';

interface Rule {
	second: number;
	count: number;
}

interface RulesConfig {
	protect: Rule;
	warning: Rule;
}

export type PageType = 'pc' | 'h5';

class Config {
	// Raptor 自定义指标 - 无限轮询
	public REDIRECT_LOOP: string = 'redirectLoop';
	// Raptor 自定义指标 - 无限轮询警告
	public REDIRECT_LOOP_WARN: string = 'redirectLoopWarn';
	// 检测为无限重定向时是否跳转
	private _isJump: boolean;
	// api 域名黑名单，黑名单中的域名不会进行记录
	private _domainBlackList: string[];
	// 无限轮询校验配置
	private _rules: RulesConfig;
	// 页面类型
	private _pageType: PageType;
	// 错误提示页地址
	private _errorTipsPageUrl: string;
	// 自定义错误提示页参数
	private _errorTipsPageQuery: Record<string,any>;
	// 禁用请求拦截
	private _disableRequestInterceptor: boolean;
	// 自定义上报工具
	private _customReporter: Record<string, unknown> | null
	constructor () {
		this._isJump = true;
		this._domainBlackList = [
			'catfront.dianping.com', 'catfront.51ping.com', 'report.meituan.com',
			'wreport.meituan.net', 'wreport1.meituan.net', 'wreport2.meituan.net',
			'lina.dianping.com', 'lina.51ping.com', 'portal-portm.sankuai.com',
			'portal-portm.meituan.com'
		];
		this._rules = {
			protect: {
				second: 10,
				count: 10
			},
			warning: {
				second: 20,
				count: 10
			}
		};
		this._customReporter = null
		this._pageType = Helpers.checkIsMobile() ? 'h5' : 'pc';
		this.setDefaultRules();
		this._errorTipsPageUrl = 'https://msstest.sankuai.com/static-test01/com.sankuai.pop.saferedirect/redirect-loop-tips/index.html';
		this._errorTipsPageQuery = {}
		this._disableRequestInterceptor = true;
	}
	get isJump (): boolean {
		return this._isJump;
	}
	set isJump (isJump: boolean) {
		if (typeof isJump === "boolean") {
			this._isJump = isJump;
		}
	}
	get domainBlackList (): string[] {
		return this._domainBlackList;
	}
	set domainBlackList (list: string[]) {
		if (Array.isArray(list) && list.length) {
			this._domainBlackList = this._domainBlackList.concat(list);
			let set: Set<string> = new Set<string>(this._domainBlackList);
			this._domainBlackList = Array.from(set);
		}
	}
	get rules (): RulesConfig {
		return this._rules;
	}
	set rules (rules: RulesConfig) {
		if (rules && rules.protect && typeof rules.protect.count === 'number' && typeof rules.protect.second === 'number') {
			rules.protect.count = rules.protect.count > 10 ? 10 : rules.protect.count;
			this._rules.protect = rules.protect;
		}
		if (rules && rules.warning && typeof rules.warning.count === 'number' && typeof rules.warning.second === 'number') {
			rules.warning.count = rules.warning.count > 10 ? 10 : rules.warning.count;
			this._rules.warning = rules.warning;
		}
	}
	get errorTipsPageQuery (): Record<string, any> {
		return this._errorTipsPageQuery;
	}
	set errorTipsPageQuery (query: Record<string, any>) {
		if (typeof query !== 'object') return;
		this._errorTipsPageQuery = query;
	}
	get errorTipsPageUrl (): string {
		return this._errorTipsPageUrl;
	}
	set errorTipsPageUrl (url: string) {
		if (!url) return;
		const urlReg = /(https?:)?\/\/.*/;
		if (!urlReg.test(url)) return;
		this._errorTipsPageUrl = url;
	}
	get disableRequestInterceptor (): boolean {
		return this._disableRequestInterceptor;
	}
	set disableRequestInterceptor (isDisable: boolean) {
		if (typeof isDisable !== 'boolean') return;
		this._disableRequestInterceptor = isDisable;
	}
	setDefaultRules (): void {
		if (this._pageType === 'pc') {
			this._rules = {
				protect: {
					second: 10,
					count: 10
				},
				warning: {
					second: 20,
					count: 10
				}
			};
		} else if (this._pageType === 'h5') {
			this._rules = {
				protect: {
					second: 15,
					count: 10
				},
				warning: {
					second: 30,
					count: 10
				}
			};
		}
	}
	set reporter (reportTool: Record<string, any> | null) {
		if (reportTool) {
			this._customReporter = reportTool
			return
		}
		if (window.Owl) {
			this._customReporter = window.Owl
			return
		}
	}
	get reporter () {
		return this._customReporter || null
	}
	get isCunstomReporter () {
		return Boolean(this._customReporter)
	}
}

export default new Config();
